// AI identify step. The associate confirms every field; nothing
// auto-saves. Enforcement lives in the real app code.

import { TouchButton } from "./MockShell";

export type AiField<T> = {
  label: string;
  suggested: T;
  confidence: number;
  value: T;
};

export type AiSuggestions = {
  make: AiField<string>;
  model: AiField<string>;
  caliber: AiField<string>;
  type: AiField<string>;
  barrel: AiField<string>;
  finish: AiField<string>;
};

type Props = {
  serial: string;
  setSerial: (v: string) => void;
  ai: AiSuggestions;
  setAi: (v: AiSuggestions) => void;
  isPmf: boolean;
  setIsPmf: (v: boolean) => void;
  onPrev: () => void;
  onNext: () => void;
};

export function AiIdentifyStep({ serial, setSerial, ai, setAi, isPmf, setIsPmf, onNext }: Props) {
  return (
    <>
      <div className="bg-white rounded-2xl p-4">
        <label
          htmlFor="serial"
          className="text-[13px] font-medium text-slate-500 uppercase tracking-wider"
        >
          Serial
        </label>
        <input
          id="serial"
          type="text"
          value={serial}
          onChange={(e) => setSerial(e.target.value.toUpperCase())}
          className="mt-1.5 w-full font-mono text-[20px] min-h-12 rounded-xl bg-slate-100 px-3 focus:outline-none focus:ring-2 focus:ring-[#007aff]/30"
        />
      </div>

      <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-2">
        {(Object.keys(ai) as (keyof AiSuggestions)[]).map((key) => {
          const f = ai[key];
          const confColor =
            f.confidence > 0.9
              ? "text-emerald-600"
              : f.confidence > 0.75
                ? "text-slate-400"
                : "text-amber-600";
          return (
            <div key={key} className="bg-white rounded-2xl p-4">
              <div className="flex items-center justify-between">
                <span className="text-[13px] font-medium text-slate-500 uppercase tracking-wider">
                  {f.label}
                </span>
                <span className={`text-[12px] font-medium tabular-nums ${confColor}`}>
                  {Math.round(f.confidence * 100)}%
                </span>
              </div>
              <input
                type="text"
                value={f.value}
                onChange={(e) =>
                  setAi({
                    ...ai,
                    [key]: { ...f, value: e.target.value },
                  } as AiSuggestions)
                }
                className="mt-1.5 w-full min-h-10 rounded-lg bg-slate-100 px-3 text-[15px] focus:outline-none focus:ring-2 focus:ring-[#007aff]/30"
              />
            </div>
          );
        })}
      </div>

      <label className="flex items-center justify-between mt-4 bg-white rounded-2xl px-4 py-3 min-h-12">
        <span className="text-[15px]">Privately made firearm</span>
        <input
          type="checkbox"
          checked={isPmf}
          onChange={(e) => setIsPmf(e.target.checked)}
          className="h-5 w-5 accent-[#052460]"
        />
      </label>

      <div className="mt-6">
        <TouchButton size="lg" full onClick={onNext}>
          Continue
        </TouchButton>
      </div>
    </>
  );
}
